/* eslint-disable */
import React, {useState} from "react";
import {Box, CircularProgress, Stack, Typography} from "@mui/material";
import {GREY, PRIMARY, WARNING} from "@/theme/palette";
import {useTranslation} from "react-i18next";
import { Icon } from '@iconify/react';
import closeSquareOutline from '@iconify/icons-eva/close-square-outline';

const FallbackImage = (
    {
        src,
        width,
        height
    }: any
): any => {
    const {t} = useTranslation();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    //console.log(error, loading);
    
    /*if(loading && !error) {
        console.log('loader img');
    }
    
    if((!loading && error)) {
        console.log('error img');
    }*/
    
    return <>
        {
            (loading && !error) &&
            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                    bgcolor: GREY["50032"],
                    width: (width || 130),
                    height: (height || 130),
                    borderRadius: 1
                }}
            >
                <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    spacing={1}
                >
                    <CircularProgress />

                    <Typography variant="caption" display="block" gutterBottom color={"primary"}>
                        {t('filepond.labelFileLoading')}
                    </Typography>
                </Stack>
            </Box>
        }

        {
            (!loading && error) &&
            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                    bgcolor: GREY["50032"],
                    width: (width || 130),
                    height: (height || 130),
                    borderRadius: 1
                }}
            >
                <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    spacing={1}
                >
                    <Icon icon={closeSquareOutline} width="40" color={PRIMARY.main}/>

                    <Typography variant="caption" display="block" gutterBottom color={"primary"}>
                        {t('common.not_found')}
                    </Typography>
                </Stack>
            </Box>
        }

        {
            (!error) &&
            <img
                src={src}
                width={width || 130}
                height={height || 130}
                style={{
                    border: `1px dotted ${PRIMARY.main}`,
                    display: (!loading) ? "block" :  "none"
                }}
                onError={() => {
                    //console.log('hola 2');
                    setError(true);
                    setLoading(false);
                }}
                onLoad={() => {
                    //console.log('hola');
                    setLoading(false);
                }}
            />
        }


    </>
}

export default FallbackImage;
